// extracted by mini-css-extract-plugin
export default {"horizontal":"lKabm","vertical":"VA0Il","center":"NvchJ","justify":"mRqev","right":"jZXgr","stretch":"gIOgS","flexStart":"HiWkg"};